import React from 'react'
import {  Box, Button, Grid, TextField,Typography } from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import { useNavigate } from 'react-router-dom';
import HeaderBox from '../../../components/HeaderBox'
// import { useState } from 'react';
import VehiceOwned from '../../../components/MasterFile/CustomerTable/VehiceOwned';
import PaymentLedger from '../../../components/MasterFile/CustomerTable/PaymentLedger';

const boxStyle = {
  root: {
    backgroundColor: 'white', 
    borderRadius: '5px',
    padding: 1
  },
};

function CustomerAddEdit() {
  const navigate = useNavigate()
  // const [isParts, setIsParts] = useState(false)
  return (
    
    <Box mt={2}>
      <Grid container spacing={1}>
      <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}> ADD CUSTOMER DETAILS</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end' >
          <Button sx={buttonStyle.root} onClick={() => navigate('/Customer_Add_Edit')}>Save</Button>&nbsp;
          <Button sx={buttonStyle.root} onClick={() => navigate('/Master')}>Cancel</Button>
          </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} mt={1}>
          <Box>
          <form>
          <Grid container spacing={1}>
              <Grid item xs={12} >
                <HeaderBox title='Customer Details'/>
              </Grid>
              
              <Grid item xs={12} >
              <Box sx={boxStyle.root} >
                <Grid container spacing={1} >
                  <Grid item xs={12} sm={6} md={1}>
                    <TextField fullWidth size='small' label="Customer ID" variant="outlined" required name='Customer ID' disabled/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.2}>
                    <TextField fullWidth size='small' label="Customer Name" variant="outlined" required name='Customer Name'/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.8}>
                    <TextField fullWidth size='small' label="Mail ID" variant="outlined" required name='Mail ID'/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField fullWidth size='small' label="Phone No" variant="outlined" required name='Phone No'/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.5}>
                    <TextField fullWidth size='small' label="Address" variant="outlined" required name='Address'/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2.5}>
                    <TextField fullWidth size='small' label="Street Name" variant="outlined" required name='Street Name'/>
                  </Grid>
                  <Grid item xs={12} sm={6} md={1}>
                    <TextField fullWidth size='small' label="Post Code" variant="outlined" required name='Post Code'/>
                  </Grid>
                </Grid>
              </Box>
              </Grid>

              <Grid item xs={12} >
                <HeaderBox 
                title='Vehicel Deatils' 
                />
                <VehiceOwned/>
              </Grid>
              <Grid item xs={12} >
                <HeaderBox title='Payment Ledger' />
                <PaymentLedger/>
              </Grid>

        
              
              {/* <Grid item xs={12}>
                <SingleAccordion component={<Complaint/>} title='Complaint'/>
              </Grid> */}

              <Grid item xs={12}>
  
              </Grid>

            </Grid> 
          </form>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default CustomerAddEdit